module.exports = __webpack_public_path__ + "static/media/img1.937290d6.png";